var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "alert-popup2",
      "size": "lg",
      "modal-class": "plan-renewable-modal",
      "centered": "",
      "title": "Plan Renewal Options",
      "hide-header-close": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-clients-header"
        }, [_c('b-button', {
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "alert-popup"
  }, [_c('p', {
    staticClass: "mb-4 text-center agreement-heading"
  }, [_c('strong', [_vm._v(" Do you want to confirm current plan to new plan? ")])]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Current Plans")]), _c('th', [_vm._v("New Plan")]), _c('th', [_vm._v("Effective Date")]), _c('th', [_vm._v("Rate")])])]), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.currentPlan.web_display_name))]), _c('td', [_vm._v(_vm._s(_vm.newPlan.web_display_name))]), _c('td', [_vm._v(_vm._s(_vm.date))]), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm.newPlan.price)))])])])])]), _c('iha-plan-changes-agreement-text', {
    attrs: {
      "currentPlan": _vm.currentPlan
    }
  })], 1), _c('br'), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "accept-btn",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.switchPlan.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isSwitch ? "Switching Plan.." : "Switch Plan") + " ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }